<ion-card class="offline"
    [color]="view.LightTheme ? 'dark' : 'light'">
    <img class="offline-loading" [src]="LoadingImageUrl" alt="">
    <ion-progress-bar color="warning" type="indeterminate"></ion-progress-bar>
    <ion-card-content>
        <b>{{ message }}</b>
    </ion-card-content>
</ion-card>
